import { Avatar } from '@mui/material';
import { jsx } from 'react/jsx-runtime';

var ColorVariant = /*#__PURE__*/function (ColorVariant) {
  ColorVariant[ColorVariant["Light"] = 0] = "Light";
  ColorVariant[ColorVariant["Dark"] = 1] = "Dark";
  return ColorVariant;
}(ColorVariant || {});
/**
 * Extract two letters from a string. For example:
 * Hello World => HW
 * Hello => HE
 */
const getLetters = name => {
  if (!name) return;
  const words = name.trim().split(' ');
  if (words.length) {
    const firstLetter = words[0]?.[0];
    const secondLetter = words.length > 1 ? words[1]?.[0] : words[0]?.[1];
    if (firstLetter && secondLetter) {
      return `${firstLetter}${secondLetter}`.toUpperCase();
    }
  }
  return name.toUpperCase();
};

/**
 * Create a number hush from a string using chareCode func
 */
const getStringHash = s => s.split('').reduce((a, b) => (a << 5) - a + b.charCodeAt(0) | 0, 0);

/**
 * Return a color by a string hash.
 */
const generateColor = (name, colorVariant = ColorVariant.Dark) => {
  const saturation = colorVariant === ColorVariant.Light ? 30 : 70;
  const defaultColor = `gray${saturation}`;
  if (!name) return defaultColor;
  const colors = [`green${saturation}`, `blue${saturation}`, `purple${saturation}`, `orange${saturation}`, `red${saturation}`, `gray${saturation}`];
  const strHash = getStringHash(name);
  const colorName = colors[Math.abs(strHash) % colors.length];
  return colorName;
};
const AvatarName = props => {
  const {
    sx,
    ...avatarProps
  } = props;
  const colorVariant = avatarProps.variant === 'square' ? ColorVariant.Light : ColorVariant.Dark;
  const color = generateColor(props.children, colorVariant);
  const label = getLetters(props.children);
  return /*#__PURE__*/jsx(Avatar, {
    sx: {
      bgcolor: theme => theme.palette[color],
      ...sx
    },
    "data-testid": "avatar-container",
    ...avatarProps,
    children: label
  });
};

export { AvatarName };
